import translatesEn from '../locales/en.json';
import translatesSv from '../locales/sv.json';
import translatesFi from '../locales/fi.json';
import translatesNo from '../locales/no.json';
import translatesDa from '../locales/da.json';

export const TRANSLATES = {
  en: translatesEn,
  sv: translatesSv,
  fi: translatesFi,
  no: translatesNo,
  da: translatesDa,
};

export const DEFAULTS = {
  LANG: 'sv',
};

export const LANGUAGES = {
  SV: 'sv',
  NO: 'no',
  EN: 'en',
  DA: 'da',
  FI: 'fi',
};

export const BTN_ACTIONS = {
  NEXT_STEP: 'NEXT_STEP',
  BEACON: 'BEACON',
  REDIRECT: 'REDIRECT',
  // A guide or other document for the step, opened in a new tab so the values
  // already typed into the form stay where they are.
  DOCUMENT: 'DOCUMENT',
  // The button that starts the connection, on the last step.
  COMPLETE: 'COMPLETE',
  // Back to the step before, in place of Cancel, for the steps that ask for it.
  BACK: 'BACK',
};
